import React from 'react';
import {useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';

import {useMarketplacePage} from '../../../api/hooks/useMarketplace.hook';
import {Product} from '../../../api/models/product';
import {setFilter} from '../../../redux';
import {FilterExpression} from '../../../utils/_enums/filter-expression.enum';
import {SortingOptionsEnum} from '../../../utils/_enums/sorting-options.enum';
import {useAppSelector} from '../../../utils/_hooks/hooks';
import {Select} from '../../_shared/select/select';
import ToggleBar from '../../_shared/toggle-bar/toggle-bar';
import styles from './upper-filter.module.scss';

const UpperFilter = () => {
    const dispatch = useDispatch();
    const data = useMarketplacePage();
    const {instances} = useAppSelector(
        (state) => ({
            instances: state.productSlice.detailedInstances
        }));
    const {
        control
    } = useForm<Product>({
        mode: 'onTouched'
    });

    const changeFilter = (isOwnerIdSet?: boolean) => {
        if (instances.filter) {
            const ownerIdFilter = isOwnerIdSet
                ? [
                    {
                        value: 'true',
                        param: 'owner',
                        comparisonType: FilterExpression.specified
                    }
                ]
                : [
                    {
                        value: 'false',
                        param: 'owner',
                        comparisonType: FilterExpression.specified
                    },
                ]
            dispatch(setFilter(
                [...instances.filter.filter(item => (item.param !== 'owner' && item.param !== 'isResale')),
                    ...ownerIdFilter]));
        }
    }

    const changeSorting = (value: SortingOptionsEnum) => {
        if (instances.filter) {
            const currFilter = instances.filter.filter(item =>
                item.param !== 'sort'
            );
            switch (value) {
                case SortingOptionsEnum.PRICE_ASC:
                    currFilter.push({
                        value: 'price,asc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    currFilter.push({
                        value: 'variant.title,asc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    break;
                case SortingOptionsEnum.PRICE_DESC:
                    currFilter.push({
                        value: 'price,desc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    currFilter.push({
                        value: 'variant.title,asc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    break;
                case SortingOptionsEnum.TITLE_ASC:
                    currFilter.push({
                        value: 'variant.title,asc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    break;
                case SortingOptionsEnum.TITLE_DESC:
                    currFilter.push({
                        value: 'variant.title,desc',
                        param: 'sort',
                        comparisonType: FilterExpression.none
                    });
                    break;
            }
            dispatch(setFilter(currFilter));
        }
    }

    if (data) {
        return (
            <div className={styles['upper-filter']}>
                <div className={styles['sort-wrapper']}>
                    <Select
                        control={control}
                        label={data.sortBy.fieldLabel}
                        placeholder={
                            data.sortBy.fieldHint
                        }
                        onChange={(value) => changeSorting(value.value)}
                        name="categoryId"
                        options={[
                            {
                                value: SortingOptionsEnum.TITLE_ASC,
                                label: data.sortByAlphabetAsc
                            }, {
                                value: SortingOptionsEnum.TITLE_DESC,
                                label: data.sortByAlphabetDesc
                            }, {
                                value: SortingOptionsEnum.PRICE_ASC,
                                label: data.sortByLowestPrice
                            }, {
                                value: SortingOptionsEnum.PRICE_DESC,
                                label: data.sortByHighestPrice
                            },
                        ]}
                    />
                </div>
                <div>
                    <ToggleBar onToggleLeft={() => changeFilter(false)}
                               onToggleRight={() => changeFilter(true)}
                               leftHeadline={data.initialSale}
                               rightHeadline={data.resale}/>
                </div>
            </div>
        );
    } else {
        return <div/>;
    }

}

export default UpperFilter;
